import React, { useEffect, useState } from "react";
import { sanityClient, urlFor } from "../lib/sanityClient";
import "../styles/Footer.css";

const QUERY = `*[_type == "footerSection"][0]{
  footerLinks, copyrightText, poweredByText, poweredByLogo,
  followUsText, socialLinks
}`;

const Footer = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    sanityClient.fetch(QUERY).then(setData);
  }, []);

  if (!data) return null;

  return (
    <div className="footer-wrapper">
      {/* New top section */}
      <div className="footer-top-section">
        <div className="footer-links">
          {(data.footerLinks || []).map((link) => (
            <a
              key={link._key}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              {link.label}
            </a>
          ))}
        </div>
      </div>

      {/* Existing footer */}
      <footer className="custom-footer">
        <div className="footer-right">
          {data.poweredByText}{" "}
          <img
            src={urlFor(data.poweredByLogo).url()}
            alt="CoRover.ai"
            className="corover-logo"
          />
        </div>

        <div className="footer-center">{data.copyrightText}</div>

        <div className="footer-left">
          <span>{data.followUsText}</span>
          {(data.socialLinks || []).map((social) => (
            <a
              key={social._key}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={social.label}
            >
              <img
                src={urlFor(social.icon).url()}
                alt={social.label}
                className="social-icon"
              />
            </a>
          ))}
        </div>
      </footer>
    </div>
  );
};

export default Footer;
